import { render, staticRenderFns } from "./languagePicker.vue?vue&type=template&id=b4c62790"
import script from "./languagePicker.vue?vue&type=script&lang=js"
export * from "./languagePicker.vue?vue&type=script&lang=js"
import style0 from "./languagePicker.vue?vue&type=style&index=0&id=b4c62790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports